/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Hilfsdialog zur Anzeige der JSON-Struktur eines Portfolios.
 * Diese Funktion steht nur im ADMIN-Mode zur Verfügung.
 * 
 * Der Dialog wird mit Alt-Click in einer Kachel gestartet.
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';

import { ModalTitle } from "./ModalTitle";

import * as utils from "../../basics/utils";
import * as appActions from "../../store/actions/appActions";
import * as fileActions from "../../store/actions/fileActions";

const styles = (theme) => ({
    form: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),

        },
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(1),
        minWidth: 600
    },

});

class UploadModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'UploadModal'
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================

    render() {
        const { file } = this.props;
        const { classes } = this.props;
        const { toolbarHeight } = this.props.app;

        const style = utils.getStyleHeight(toolbarHeight, .5, .5, .25);
        const styleError = utils.getStyleHeight(toolbarHeight, .5, .5, .20);


        const renderProgressBar = () => {
            if (file.progress === 0 || file.total === 0) return null;
            if (file.progress === null || file.total === null) return null;

            const helpCurrentBytes = Math.min(file.progress, file.total);

            const percent = parseInt(100.0 / file.total * file.progress);

            const bytes = '' + utils.humanFileSize(helpCurrentBytes) + ' / ' + utils.humanFileSize(file.total);
            const width = `${percent}%`;

            const styleValues = utils.getStyleHeight(toolbarHeight, .4, .4, .20);
            const styleProgressBar = { backgroundColor: 'rgb(35,186,44)', width, ...styleValues };

            return (
                <div className="w-full flex flex-col ">
                    <div className="w-full text-black" style={styleValues}>{bytes}</div>
                    <div className="w-full rounded bg-gray-200">
                        <div className="rounded text-center font-bold text-gray-600" style={styleProgressBar}>{width}</div>
                    </div>
                </div>
            )
        }

        const renderErrorMessage = () => {
            if (file.error === null) return null;

            const styleMessage = { backgroundColor: 'rgb(145,28,33)', width: '100%', ...style };
            const message = 'FEHLER: Datei konnte nicht hochgeladen werden!';

            return (
                <div className="w-full flex flex-col">
                    <div className="bg-white text-black" style={style}>{message}</div>
                    <div className="text-center text-white" style={styleMessage}>{file.error}</div>
                </div>
            )
        }

        const onCancel = () => {
            this.props.uploadFileHidden(true);
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        if (file.type === 'FILE_UPLOAD_PROGRESS' && !file.hidden) {
            let fileName = '';
            let dialogTitle = 'Bild hochladen';
            if (file.name) {
                const fileDetails = utils.getCommonFileDetails(file.name);
                fileName = fileDetails.name;
                if (fileDetails.ext === 'pdf') dialogTitle = 'PDF-Dokument hochladen'
                if (fileDetails.ext === 'mp4') dialogTitle = 'Video hochladen'
            }

            return (
                <Dialog open={true} maxWidth={'md'}>
                    <ModalTitle onClose={onCancel}>{dialogTitle}</ModalTitle>
                    <DialogContent>
                        <FormControl className={classes.formControl}>
                            <div className="font-bold" style={style}>{fileName}</div>
                            {renderProgressBar()}
                            {renderErrorMessage()}
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCancel} variant="contained" color="default">OK</Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            if (file.error) {
                return (
                    <Dialog open={true} onClose={onCancel} maxWidth={'md'}>
                        <ModalTitle onClose={onCancel}>FEHLER</ModalTitle>
                        <DialogContent>
                            <div className="font-semibold" style={styleError}>{file.error}</div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onCancel} variant="contained" color="default">OK</Button>
                        </DialogActions>
                    </Dialog>
                )
            }
        }
        return null;
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        file: state.file
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UploadModal));
